export default __webpack_public_path__ + "static/pic1-1f3a28a03d5bcf59762968cfbff33d77.jpeg";